import { jsxs as g, jsx as o } from "react/jsx-runtime";
import { I as x, J as N, K, t as P, d as T, j as B, L as R, M as w } from "../../../vendor-Dd6qj6gJ.js";
import { forwardRef as A, useRef as $, useContext as v } from "react";
import { BaseIcon as h } from "../../BaseIcon/index.js";
import { ItemRow as C } from "../../ItemRow/index.js";
import { Tag as I } from "../../Tag/index.js";
import { useSelectFieldValueContext as L } from "../SelectFieldContext/index.js";
import { c as r } from "../../../styles.module-BOlArovb.js";
const j = ({ buttonRef: d }) => {
  const n = v(x), { selectedItems: l } = L();
  if (!n || n.selectionManager.selectedKeys.size === 0)
    return null;
  const i = Array.from(n.selectionManager.selectedKeys), u = i.map((e) => {
    const t = l.get(e);
    return {
      id: String(e),
      textValue: t?.label ?? String(e),
      icon: t?.decorationLeft?.iconProps?.icon
    };
  });
  return /* @__PURE__ */ o(
    R,
    {
      "aria-label": "Selected options",
      className: r.tagGroup,
      onAction: () => {
        n.open();
      },
      onRemove: (e) => {
        const t = new Set(e), c = i.filter(
          (a) => !t.has(String(a)) && !t.has(a)
        );
        n.setValue(c), c.length === 0 && d.current && d.current.focus();
      },
      children: /* @__PURE__ */ o(w, { items: u, className: r.tagList, children: (e) => /* @__PURE__ */ o(I, { id: e.id, icon: e.icon, textValue: e.textValue, color: "blue" }) })
    }
  );
}, q = A(
  function({ placeholder: n, startIcon: l, ...i }, u) {
    const e = $(null), t = v(x), c = () => {
      t && (t.setValue([]), e.current?.focus());
    }, a = $(null), { hoverProps: S, isHovered: V } = N({}), { pressProps: y, isPressed: M } = K({
      onPress: c
    }), f = t ? Array.from(t.selectionManager.selectedKeys) : [], m = f.length > 0, p = (s) => {
      let b = s.target;
      b && (a.current?.contains(b) || e.current && (e.current.focus(), e.current.click()));
    };
    return /* @__PURE__ */ g(
      P,
      {
        ...i,
        ref: u,
        className: r.selectValue,
        onClick: p,
        onTouchEnd: p,
        onKeyDownCapture: (s) => {
          s.target == e.current && s.key == "Backspace" && (s.preventDefault(), s.stopPropagation(), c());
        },
        children: [
          /* @__PURE__ */ g("div", { className: r.multiValue, children: [
            l ? /* @__PURE__ */ o(C.DecorationLeft, { iconProps: { icon: l } }) : null,
            m ? /* @__PURE__ */ o(j, { buttonRef: e }) : /* @__PURE__ */ o("span", { className: r.placeholder, children: n })
          ] }),
          m && /* @__PURE__ */ o(
            "button",
            {
              ...y,
              ...S,
              "data-hovered": V || void 0,
              "data-pressed": M || void 0,
              type: "button",
              ref: a,
              tabIndex: -1,
              "aria-label": `Clear all ${f.length} selected options`,
              className: T(r.multiTriggerButton, r.clearButton),
              children: /* @__PURE__ */ o(h, { color: "moon", icon: "close" })
            }
          ),
          /* @__PURE__ */ o(B, { ref: e, className: r.multiTriggerButton, children: /* @__PURE__ */ o(h, { color: "moon", icon: "chevron-down", className: r.chevron }) })
        ]
      }
    );
  }
);
export {
  q as MultiSelectValue
};
